import React, { useMemo, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ButtonGroup,
  Container,
  Row,
  Col,
  Spinner,
  Badge,
} from 'reactstrap';
import { useStripe } from '@stripe/react-stripe-js';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import clsx from 'clsx';

import MainLayout from '../../layouts/MainLayout';
import useQueryParams from '../../hooks/useQuery';
import { fetchPackages } from '../../api/actions/stripe';
import { fetcher } from '../../api/client';
import { changePlan } from '../../api/actions/profile';
import { useChangePlan, useProfile } from '../../api/hooks/profile';
import { usePackages } from '../../api/hooks/stripe';
import Title from '../../components/Title';

import Promo from '../../components/Promo';

import { getPrice, getPriceAmount } from '../../utils';
import config from '../../config';
import { oneTimeProducts, recurringProducts } from './constants';

import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLanguages } from '../../hooks/useLanguages';

const DISCOUNT = 0;

export function MonthlyPlans() {
  const { t } = useTranslation('common');
  const benefits = {
    free: [
      t('Plans.monthlyPlansBenefits.free.0'),
      t('Plans.monthlyPlansBenefits.free.1'),
      t('Plans.monthlyPlansBenefits.free.2'),
    ],
    basic: [
      t('Plans.monthlyPlansBenefits.basic.0'),
      t('Plans.monthlyPlansBenefits.basic.1'),
      t('Plans.monthlyPlansBenefits.basic.2'),
      t('Plans.monthlyPlansBenefits.basic.3'),
      t('Plans.monthlyPlansBenefits.basic.4'),
    ],
    premium: [
      t('Plans.monthlyPlansBenefits.premium.0'),
      t('Plans.monthlyPlansBenefits.premium.1'),
      t('Plans.monthlyPlansBenefits.premium.2'),
      t('Plans.monthlyPlansBenefits.premium.3'),
      t('Plans.monthlyPlansBenefits.premium.4'),
      t('Plans.monthlyPlansBenefits.premium.5'),
    ],
  };
  const stripe = useStripe();
  const { mutate: changePlanMutate } = useChangePlan();
  const currency = 'mxn';
  const { profile } = useProfile();
  const [plans, setPlans] = useState({});
  const meta = {
    productId: 'starter_plan',
    type: 'service',
    currency,
  };
  const { data = [], isLoading } = usePackages(meta, {
    onSuccess: (data) => {
      // setPackages(data?.data?.map((packageObj) => {
      //   const splitPackageName = packageObj.id.split('_');
      //   const isPlan = packageObj.object === 'plan';
      //   return {
      //     id: packageObj.id,
      //     type: packageObj.object,
      //     name: isPlan ?  packageObj.nickname : packageObj.attributes.name,
      //     index: isPlan ?  splitPackageName[0] : packageObj.attributes.index,
      //     label: getLabel(selectedProduct, packageObj),
      //     value: isPlan && selectedProduct.value === 'starter_plan' ? splitPackageName[1]: splitPackageName[0],
      //     price: getPrice(packageObj?.price ?? packageObj?.amount, packageObj.currency, false),
      //     currency: packageObj.currency
      //   }
      // }).sort((a,b) => a.index - b.index))
      setPlans({
        basic: data.data.find((d) => d.id.includes('basic_starter_plan_mx')),
        premium: data.data.find((d) =>
          d.id.includes('1_premium_starter_plan_mx')
        ),
      });
    },
  });

  const handlePurchase = async (plan) => {
    console.log({ plan });
    const { id, name, object } = plan.stripeInfo;
    if (plan.type === 'free') {
      changePlanMutate({ type: 'free' });
    } else {
      await stripe.redirectToCheckout({
        successUrl: `${
          config.baseUrl
        }/checkout/success?productId=${id}&productName=${encodeURIComponent(
          name
        )}`,
        cancelUrl: `${config.baseUrl}/plans/monthly?currency=${currency}`,
        mode: 'subscription',
        lineItems: [
          {
            price: id,
            quantity: 1,
          },
        ],
        clientReferenceId: profile.organization,
        customerEmail: profile.email,
        // locale: 'mx'
      });
    }
  };

  return (
    <Container class="py-4 mb-4">
      <Row className="mt-4">
        <Col sm={4}>
          <PlanItem
            type="free"
            name={t('Plans.monthlyPlansBenefits.free.title')}
            price={t('Plans.monthlyPlansBenefits.free.price')}
            benefits={benefits.free}
            isCurrent={profile.plan?.type === 'free'}
            onPurchase={handlePurchase}
          />
        </Col>
        <Col sm={4}>
          <PlanItem
            type="basic"
            name={t('Plans.monthlyPlansBenefits.basic.title')}
            price={getPrice(plans.basic?.amount, plans.basic?.currency, true)}
            originalPrice={getPrice(
              (plans.basic?.amount * 100) / DISCOUNT + 100,
              plans.premium?.currency,
              true
            )}
            stripeInfo={plans.basic}
            isLoading={isLoading}
            discount={DISCOUNT}
            // currency="mxn"
            benefits={benefits.basic}
            isCurrent={profile.plan?.type === 'basic'}
            onPurchase={handlePurchase}
          />
        </Col>
        <Col sm={4}>
          <PlanItem
            type="premium"
            name={t('Plans.monthlyPlansBenefits.premium.title')}
            price={getPrice(
              plans.premium?.amount,
              plans.premium?.currency,
              true
            )}
            originalPrice={getPrice(
              (plans.premium?.amount * 100) / DISCOUNT + 100,
              plans.premium?.currency,
              true
            )}
            isLoading={isLoading}
            stripeInfo={plans.premium}
            discount={DISCOUNT}
            // currency="mxn"
            benefits={benefits.premium}
            isCurrent={profile.plan?.type === 'premium'}
            onPurchase={handlePurchase}
          />
        </Col>
      </Row>
    </Container>
  );
}

function PlanItem(props) {
  const {
    type,
    name,
    price,
    currency,
    benefits = [],
    isCurrent,
    isLoading,
    discount,
    originalPrice,
    onPurchase,
  } = props;

  const handlePurchase = () => {
    onPurchase(props);
  };
  const { t } = useTranslation('common');
  console.log({ price });
  return (
    <div className="rounded-lg bg-white d-flex flex-column justify-content-between p-4 flex-auto h-100">
      <div>
        <div className="border-bottom pb-3">
          <h3 className="font-weight-bold font-size-32">{name} </h3>
          <div className="d-flex align-items-center">
            <PriceLabel
              discount={discount}
              price={discount ? originalPrice : price}
              currency={currency}
              hidden={isLoading}
            />
            <Badge
              className="ml-2"
              color="accent"
              size="xl"
              hidden={!discount || isLoading}
            >
              {discount}%
            </Badge>
          </div>
          <PriceLabel
            price={price}
            currency={currency}
            hidden={isLoading || !discount}
          />
          <div className="text-center" hidden={!isLoading}>
            <Spinner />
          </div>
          <div className="font-size-14 text-accent" hidden={!discount}>
            Vigencia al 15 de octubre del 2022
          </div>
        </div>

        <div className="p-4">
          {benefits.map((benefit) => (
            <div className="d-flex p-2">
              <div>
                <FontAwesomeIcon
                  icon="check-circle"
                  className="text-accent"
                  size="lg"
                />
              </div>
              <div className="ml-2 text-muted">{benefit}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="w-100" hidden={isLoading}>
        <Button
          className="w-100"
          color={isCurrent ? 'accent' : 'accent-100'}
          disabled={isCurrent}
          onClick={handlePurchase}
        >
          {isCurrent
            ? t('Plans.buttons.current')
            : type === 'free'
            ? t('Plans.buttons.change')
            : t('Plans.buttons.buy')}
        </Button>
      </div>
    </div>
  );
}

function PriceLabel({ hidden, price, currency, discount }) {
  return (
    <div
      className={clsx(
        'font-weight-bold',
        discount ? 'text-strikethrough text-muted font-size-24' : 'font-size-42'
      )}
      hidden={hidden}
    >
      {price} <span className="text-uppercase">{currency}</span>
    </div>
  );
}
